const AI_CHATBOT_CMS_PROMPT_QUERY_KEYS = "ai-chatbot-cms-prompt";

export const aiChatbotCmsPromptQueryKeys = {
  all: [AI_CHATBOT_CMS_PROMPT_QUERY_KEYS] as const,
  inChat: function inChat() {
    return [AI_CHATBOT_CMS_PROMPT_QUERY_KEYS, "in-chat"] as const;
  },
  inPage: function inPage() {
    return [AI_CHATBOT_CMS_PROMPT_QUERY_KEYS, "in-page"] as const;
  },
};
